import UrgentCampaigns from './UrgentCampaigns.page';

export default UrgentCampaigns;
